import { render } from "./userInfo.vue?vue&type=template&id=4953332b&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=4953332b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4953332b"]])

export default __exports__